module.exports = __webpack_public_path__ + "static/icons/icon-pagoefectivo-logo.dcf7a86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-tarjeta-credito/icon-pagoefectivo-logo.svg
// module id = onsR
// module chunks = 1